import React, { Fragment } from "react";

import {
  Container,
  Content,
  Circle,
  Contact,
  ContainerContact,
  ContainerContacts,
  Dash,
  ButtonStyled,
} from "./Feedback.styles";
import {
  Header,
  Button,
  ButtonProps,
  HeaderNavigation,
  HeaderNavigationParams,
} from "../../Components";
import Check from "@mui/icons-material/Check";
import Close from "@mui/icons-material/Close";

import Success from "../../Assets/Illustrations/success.svg";
import SupportHelping from "../../Assets/Illustrations/support-helping.svg";
import AnalysisPaper from "../../Assets/Illustrations/analysis-paper.svg";
import DisconnectedInternetCable from "../../Assets/Illustrations/disconnected-internet-cable.svg";
import SuccessCellphone from "../../Assets/Illustrations/success-cellphone.svg";
import AlreadyCreated from "../../Assets/Illustrations/already-created.svg";
import SomeDataMissing from "../../Assets/Illustrations/some-data-missing.svg";
import UserNotFound from "../../Assets/Illustrations/user-not-found.svg";
import PersonWithKey from "../../Assets/Illustrations/person-with-key.svg";

import WhatsApp from "@mui/icons-material/WhatsApp";

export type ImagesType =
  | "sucess"
  | "supportHelping"
  | "analysisPaper"
  | "disconnectedInternetCable"
  | "successCellphone"
  | "alreadyCreated"
  | "someDataMissing"
  | "userNotFound"
  | "personWithKey";

export type IconsType = "whatsapp";
export interface ContactsProps {
  name: string;
  contact: string;
  type: IconsType;
  link(): void;
}

export interface FeedbackScreenProps {
  title: string;
  description: string;
  image: ImagesType;
  type: "success" | "denied" | "warning";
  contacts?: ContactsProps[];
  buttons?: {
    params?: ButtonProps;
    text: string;
  }[];
  headerNavigation?: HeaderNavigationParams;
}

export const FeedbackScreen: React.FC<FeedbackScreenProps> = ({
  title,
  description,
  buttons,
  type,
  image,
  contacts,
  headerNavigation,
}) => {
  const images: {
    [keyof in ImagesType]: string;
  } = {
    sucess: Success,
    supportHelping: SupportHelping,
    analysisPaper: AnalysisPaper,
    disconnectedInternetCable: DisconnectedInternetCable,
    successCellphone: SuccessCellphone,
    alreadyCreated: AlreadyCreated,
    someDataMissing: SomeDataMissing,
    userNotFound: UserNotFound,
    personWithKey: PersonWithKey,
  };

  const setIcon = () => {
    if (type === "denied") {
      return <Close style={{ color: "#FFF" }} width={15} height={15} />;
    }

    if (type === "success") {
      return <Check style={{ color: "#FFF" }} width={21.05} height={14.43} />;
    }

    if (type === "warning") {
      return <Check style={{ color: "#FFF" }} width={4} height={18.4} />;
    }
  };

  const icons: {
    [keyof in IconsType]: any;
  } = {
    whatsapp: <WhatsApp style={{ color: " #006bee" }} />,
  };

  return (
    <Container>
      <Header />

      <Content>
        <HeaderNavigation
          marginTop="none"
          onClick={headerNavigation?.onClick}
          hide={!headerNavigation || headerNavigation?.hide}
        />
        <div className="containerInfo">
          <Circle status={type}>{setIcon()}</Circle>

          <img
            src={images[image]}
            alt="Logo RV Point"
            style={{ maxWidth: 450, alignSelf: "center" }}
          />

          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        {contacts?.length && (
          <>
            <Dash />
            <ContainerContacts>
              <h3>Centrais de relacionamento</h3>
              {contacts?.map((contact, index) => (
                <Fragment key={`contact-${contact.name}-${contact.contact}`}>
                  <ContainerContact>
                    <ButtonStyled
                      variant="text"
                      startIcon={icons[contact.type]}
                      onClick={contact.link}
                    >
                      <Contact>
                        <p>{contact.name}</p>
                        <p>{contact.contact}</p>
                      </Contact>
                    </ButtonStyled>
                  </ContainerContact>
                  {index !== contacts?.length - 1 && <Dash />}
                </Fragment>
              ))}
            </ContainerContacts>
          </>
        )}

        {buttons?.length && (
          <div className="centerButton">
            {buttons.map(({ params = {}, text }) => (
              <Button key={`button-${text}`} {...params} textTransform="none">
                {text}
              </Button>
            ))}
          </div>
        )}
      </Content>
    </Container>
  );
};
